import G6 from '@antv/g6';
import insertCss from 'insert-css';
import { downloadData } from '@/utils/reuse';
import store from '@/store';

insertCss(`
.g6-component-toolbar {
  // top: 5px !important;
  display: flex;
  height: 2.8rem;
  min-height: 37px;
  border-radius: .5rem;
  padding: 0px;
  font-size: 1.375rem;
  // padding: 12px 0 4px 0;
  margin: 0 auto;
  align-items: center;
  margin-top: 1.3rem;
}
.g6-component-toolbar li {
  height: auto !important;
}
`);
// import graphReactor from '@/graphReactor';
// plugins
const minimap = new G6.Minimap({
  size: [50, 50],
  className: 'minimap',
  type: 'delegate',
});
// highlight plugins
const tooltip = new G6.Tooltip({
  offsetX: 10,
  offsetY: 10,
  fixToNode: [1, 0.5],
  // the types of items that allow the tooltip show up
  // 允许出现 tooltip 的 item 类型
  itemTypes: ['node', 'edge'],
  // custom the tooltip's content
  // 自定义 tooltip 内容
  getContent: (e) => {
    const outDiv = document.createElement('div');
    outDiv.style.width = '250px';
    outDiv.style.height = 'auto';
    const model = e.item.getModel();
    if (e.item.getType() === 'node') {
      // console.log(model, 'its model');
      if (model.tjType === 'note-text') {
        outDiv.innerHTML = `${model.description}`;
      } if (model.tjType === 'custom-node') {
        outDiv.innerHTML = `${model.label}`;
      } else {
        outDiv.innerHTML = `${model.label}`;
      }
    } else {
      const source = e.item.getSource();
      const target = e.item.getTarget();
      outDiv.innerHTML = `source: ${source.getModel().label} ${source.getModel().id}<br/>target: ${target.getModel().id}`;
    }
    return outDiv;
  },
});

const toolbar = new G6.ToolBar({
  position: {
    x: 350,
    y: -12,
  },
  getContent: () => {
    const outDiv = document.createElement('ul');
    outDiv.class = 'tip-above';
    outDiv.innerHTML = `
    <li code="undo"><i class='bx bx-undo' color="black"></i></li>
    <li code="redo"><i class='bx bx-redo' color="black"></i></li>
    <li code="download"><i class='bx bxs-download' ></i></li>
    <li code="upload"><i class='bx bx-upload' ></i></li>
    <li code="fit"><i class='bx bx-exit-fullscreen'></i></li>`;
    return outDiv;
  },
  handleClick: (code, graph) => {
    console.log(code, graph);
    if (code === 'undo') {
      toolbar.undo();
    } else if (code === 'redo') {
      toolbar.redo();
    } else if (code === 'download') {
      downloadData(graph.save());
    } else if (code === 'upload') {
      store.dispatch('setUploadingG6Data');
    } else if (code === 'fit') {
      graph.fitView();
    }
  },
});

export {
  minimap,
  tooltip,
  toolbar,
};
